import CustomField from "components/Common/CustomField"
import CustomLabel from "components/Common/CustomLabel"
import { ErrorMessage, Field, Form, Formik } from "formik"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import { getDropdownData } from "store/actions/commonAction"
import { createInterviewSchedule } from "store/actions/interviewsAction"
import { showAlert } from "store/reducers/alertReducer"
import * as Yup from "yup"
import MatchedCandidates from "./MatchedCandidates"
import { Calendar } from "primereact/calendar"
import Select from "react-select"

const initialValues = {
  title: "",
  title_ar: "",
  description: "",
  description_ar: "",
  start_date: "",
  end_date: "",
  start_time: "",
  end_time: "",
  total_capacity: "",
  city_ids: [],
  specialization_id: "",
  gender: "",
  nationality_id: "",
  education_qualification_id: "",
  employee_experience: "",
  employee_experience_as_per_document: "",
  national_ids: "",
}

const CreateInterviewSchedule = () => {
  const { loading, interviewsList, isLoading, totalCount } = useSelector(
    state => state.Interviews
  )
  const { dropdownData } = useSelector(state => state.Common)
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(!modal)

  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchDropdownApi = () => {
      const payload = {
        type: "all",
      }
      dispatch(getDropdownData(payload))
    }
    fetchDropdownApi()
  }, [])

  const [formValues, setFormValues] = useState(initialValues)

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Field is required"),
    title_ar: Yup.string().required("Field is required"),
    // description: Yup.string().required("Field is required"),
    // description_ar: Yup.string().required("Field is required"),
    start_date: Yup.date().required("Field is required"),
    // end_date: Yup.date().required("Field is required"),
    start_time: Yup.string().required("Field is required"),
    end_time: Yup.string().required("Field is required"),
    total_capacity: Yup.number()
      .required("Field is required")
      .positive()
      .integer(),
    // city_ids: Yup.string().required("Field is required"),
    // specialization_id: Yup.string().required("Field is required"),
    // gender: Yup.string().required("Field is required"),
    // nationality_id: Yup.string().required("Field is required"),
    // employee_experience: Yup.string().required("Field is required"),
    // education_qualification_id: Yup.string().required("Field is required"),
    national_ids: Yup.string().matches(
      /^(\d+(,\s?\d+)*)?$/,
      "Invalid format. Use only numbers separated by commas."
    ),
  })

  const handleOnSubmit = values => {
    const formattedNationalIds = [
      ...new Set(
        values.national_ids
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "") // Remove empty values
      ),
    ]

    const updatedCitiesId = values?.city_ids?.map(item => item.value) || []

    const updatedValues = {
      ...values,
      national_ids: formattedNationalIds,
      city_ids: updatedCitiesId,
    }

    // console.log(updatedValues)
    dispatch(createInterviewSchedule(updatedValues))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          navigate(-1)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h4 className="card-title ">Create Interview Schedule</h4>
          <Card>
            <CardBody>
              <Formik
                initialValues={formValues}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={handleOnSubmit}
              >
                {({ values, errors, touched, setFieldValue }) => (
                  <Form>
                    <Row>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="title"
                            label={t("Title (English)")}
                            isRequired={true}
                          />
                          <CustomField
                            name="title"
                            type="text"
                            placeholder={t("Title (English)")}
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="title_ar"
                            label={t("Title (Arabic)")}
                            isRequired={true}
                          />
                          <CustomField
                            name="title_ar"
                            type="text"
                            placeholder={t("Title (Arabic)")}
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="description"
                            label={t("Description (English)")}
                            // isRequired={true}
                          />
                          <CustomField
                            name="description"
                            type="text"
                            placeholder={t("Description (English)")}
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="description_ar"
                            label={t("Description (Arabic)")}
                            // isRequired={true}
                          />
                          <CustomField
                            name="description_ar"
                            type="text"
                            placeholder={t("Description (Arabic)")}
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="start_date"
                            label={t("Date")}
                            isRequired={true}
                          />
                          <CustomField
                            name="start_date"
                            type="date"
                            placeholder="dd-mm-yyyy"
                            touched={touched}
                            errors={errors}
                          />
                          {/* <div className="w-100 custom_date_picker">
                            <Calendar
                              id={values.start_date}
                              value={
                                values.start_date
                                  ? new Date(values.start_date)
                                  : null
                              }
                              onChange={e => {
                                console.log(first)
                                setFieldValue("start_date", e.value)
                              }}
                              dateFormat="dd-mm-yy"
                              placeholder={t("DD-MM-YYYY")}
                              // showIcon
                              showButtonBar
                            />
                          </div> */}
                        </div>
                      </Col>
                      {/* <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="end_date"
                            label={t("End Date")}
                            isRequired={true}
                          />
                          <CustomField
                            name="end_date"
                            type="date"
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col> */}
                      <Col lg={3}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="start_time"
                            label={t("Start Time")}
                            isRequired={true}
                          />
                          <CustomField
                            name="start_time"
                            type="time"
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="end_time"
                            label={t("End Time")}
                            isRequired={true}
                          />
                          <CustomField
                            name="end_time"
                            type="time"
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="total_capacity"
                            label={t("Total Capacity")}
                            isRequired={true}
                          />
                          <CustomField
                            name="total_capacity"
                            type="number"
                            touched={touched}
                            errors={errors}
                          />
                        </div>
                      </Col>
                      {/* <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="specialization_id"
                            label={t("Specialization")}
                            // isRequired={true}
                          />
                          <Field
                            as="select"
                            name="specialization_id"
                            className={`form-control ${
                              errors.specialization_id &&
                              touched.specialization_id
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option
                              disabled
                              label={t("Select Specialization")}
                            />
                            <option value={"15 Min"} label={"15 "} />
                          </Field>
                          <ErrorMessage
                            name={"specialization_id"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col> */}
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="city_ids"
                            label={t("Cities")}
                            // isRequired={true}
                          />
                          {/* <Field
                            as="select"
                            name="city_ids"
                            className={`form-control ${
                              errors.city_ids && touched.city_ids
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option disabled label={t("Select city")} />
                            {dropdownData?.cities?.map(item => (
                              <option
                                key={item?.id}
                                value={item?.id}
                                label={item?.name}
                              />
                            ))}
                          </Field> */}
                          <Select
                            name={values.city_ids}
                            value={values.city_ids}
                            isMulti={true}
                            onChange={e => {
                              setFieldValue("city_ids", e)
                            }}
                            options={dropdownData?.cities?.map(item => ({
                              label: item.name,
                              value: item.id,
                            }))}
                            className={`react-select-container`}
                            placeholder={`${" "} ${t("Select cities")}`}
                            closeMenuOnSelect={false}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="gender"
                            label={t("Gender")}
                            // isRequired={true}
                          />
                          <Field
                            as="select"
                            name="gender"
                            className={`form-control ${
                              errors.gender && touched.gender
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option disabled label={t("Select Gender")} />

                            <option value={"male"} label={"Male"} />
                            <option value={"female"} label={"Female"} />
                          </Field>
                          <ErrorMessage
                            name={"gender"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="specialization_id"
                            label={t("Specialization")}
                            // isRequired={true}
                          />
                          <Field
                            as="select"
                            name="specialization_id"
                            className={`form-control ${
                              errors.specialization_id &&
                              touched.specialization_id
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option
                              disabled
                              label={t("Select Specialization")}
                            />
                            {dropdownData?.spacialization?.map(item => (
                              <option
                                key={item?.id}
                                value={item?.id}
                                label={item?.name}
                              />
                            ))}
                          </Field>
                          <ErrorMessage
                            name={"specialization_id"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="national_ids"
                            label={t("National ID / Iqama ID")}
                          />

                          <Field
                            as="textarea"
                            name="national_ids"
                            className="form-control"
                            placeholder={t(
                              "Please enter national Id/ Iqama Id: eg. 1234657890, 2345678910"
                            )}
                          ></Field>
                          <ErrorMessage
                            name={"national_ids"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="nationality_id"
                            label={t("Nationality")}
                            // isRequired={true}
                          />
                          <Field
                            as="select"
                            name="nationality_id"
                            className={`form-control ${
                              errors.nationality_id && touched.nationality_id
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option
                              disabled
                              label={t("Select Your Nationality")}
                            />
                            <option value={"153"} label={"Saudi"} />
                            <option value={"1"} label={"Non Saudi"} />
                            {/* {dropdownData?.nationalities?.map(item => (
                              <option
                                key={item?.id}
                                value={item?.id}
                                label={item?.name}
                              />
                            ))} */}
                          </Field>
                          <ErrorMessage
                            name={"nationality_id"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="education_qualification_id"
                            label={t("Education Qualification")}
                            // isRequired={true}
                          />
                          <Field
                            as="select"
                            name="education_qualification_id"
                            className={`form-control ${
                              errors.education_qualification_id &&
                              touched.education_qualification_id
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option
                              disabled
                              label={t("Select Education qualification")}
                            />
                            {dropdownData?.education_qualifications?.map(
                              item => (
                                <option
                                  key={item?.id}
                                  value={item?.id}
                                  label={item?.name}
                                />
                              )
                            )}
                          </Field>
                          <ErrorMessage
                            name={"education_qualification_id"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="form_field">
                          <CustomLabel
                            htmlFor="employee_experience"
                            label={t("Employee Experience")}
                            // isRequired={true}
                          />
                          <Field
                            as="select"
                            name="employee_experience"
                            className={`form-control ${
                              errors.employee_experience &&
                              touched.employee_experience
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option
                              disabled
                              label={t("Select Employee Experience")}
                            />

                            <option value={"1"} label={"Experienced "} />
                            <option value={"2"} label={"New"} />
                          </Field>
                          <ErrorMessage
                            name={"employee_experience"}
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="g_end mt-2 gap-3">
                          <button
                            className="main_btn disabled-button fit_content px-4"
                            type="button"
                            onClick={() => navigate(-1)}
                            disabled={isLoading}
                          >
                            Cancel
                          </button>
                          <button
                            className="main_btn fit_content px-4"
                            type="button"
                            onClick={toggle}
                          >
                            View Matching Candidates
                          </button>
                          <button
                            className="main_btn fit_content px-4"
                            type="submit"
                            disabled={isLoading}
                          >
                            Notify Candidates
                          </button>
                        </div>
                      </Col>
                    </Row>
                    <Modal
                      isOpen={modal}
                      toggle={toggle}
                      className="full_screen_modal"
                    >
                      <ModalHeader toggle={toggle}>
                        Matched Candidates List{" "}
                        {totalCount ? `(${totalCount})` : ""}
                      </ModalHeader>
                      <ModalBody className="pt-0">
                        <MatchedCandidates values={values} />
                      </ModalBody>
                      {/* <ModalFooter>
                        <Button color="secondary" onClick={toggle}>
                          Close
                        </Button>
                      </ModalFooter> */}
                    </Modal>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreateInterviewSchedule
